var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 20,
    viewBox: "0 0 43 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 41,
    height: 18,
    rx: 5,
    fill: "#FF5917"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56889 13H11.3654C12.8356 13 13.6186 12.233 13.6186 11.1911C13.6186 10.2227 12.9251 9.63778 12.1804 9.60263V9.53871C12.8612 9.3853 13.3629 8.9027 13.3629 8.13246C13.3629 7.15128 12.6342 6.45455 11.1896 6.45455H8.56889V13ZM9.95277 11.8686V10.13H11.1129C11.7777 10.13 12.19 10.5135 12.19 11.0536C12.19 11.5458 11.8544 11.8686 11.081 11.8686H9.95277ZM9.95277 9.19354V7.57315H11.0043C11.6179 7.57315 11.9663 7.88956 11.9663 8.36257C11.9663 8.88033 11.5444 9.19354 10.9787 9.19354H9.95277ZM15.4191 13H19.8424V11.859H16.803V10.2962H19.6027V9.15518H16.803V7.59553H19.8296V6.45455H15.4191V13ZM21.5805 7.59553H23.5844V13H24.9523V7.59553H26.9563V6.45455H21.5805V7.59553ZM29.0612 13L29.5469 11.5075H31.9088L32.3946 13H33.8776L31.6212 6.45455H29.8378L27.5782 13H29.0612ZM29.8985 10.4272L30.7039 7.95028H30.755L31.5604 10.4272H29.8985Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 41,
    height: 18,
    rx: 5,
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeta);
export default __webpack_public_path__ + "static/media/beta.7e9e1586dfabc944315825f422d05806.svg";
export { ForwardRef as ReactComponent };